import { Credentials } from '../types';
import { AWSCredentialsSet } from './types';

export class AWSCredentials implements Credentials {
  constructor(
    private _secretAccessKey: string,
    private _accessKeyId: string,
    private _sessionToken: string,
    private _jwtToken: string
  ) {}

  public getFormatted(): AWSCredentialsSet {
    return {
      secretAccessKey: this._secretAccessKey,
      accessKeyId: this._accessKeyId,
      sessionToken: this._sessionToken
    };
  }

  public get secretAccessKey(): string {
    return this._secretAccessKey;
  }

  public get accessKeyId(): string {
    return this._accessKeyId;
  }

  public get sessionToken(): string {
    return this._sessionToken;
  }

  public get jwtToken(): string {
    return this._jwtToken;
  }
}
